{
  "close": "Uždaryti",
  "notifications": "Pranešimai"
}
